var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DialogFullSize",
    {
      ref: "importPopup",
      staticClass: "import-popup",
      class: { "flatfile-step": _vm.getCurrentStepId === 4 },
      attrs: { title: _vm.title },
      on: { handleClose: _vm.closed }
    },
    [
      _c(
        "div",
        { staticClass: "content", attrs: { slot: "content" }, slot: "content" },
        [
          _vm.getCurrentStepId === 1
            ? _c("ImportChoiceTypeStep", {
                staticClass: "step-content",
                on: { onClickContinue: _vm.onClickContinue }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getCurrentStepId === 2
            ? _c("ImportPrepareStep", { staticClass: "step-content" })
            : _vm._e(),
          _vm._v(" "),
          _vm.getCurrentStepId === 3
            ? _c(
                "div",
                { staticClass: "setup-import" },
                [_c("ImportSetupStep", { staticClass: "step-content" })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getCurrentStepId === 4
            ? _c(
                "div",
                { staticClass: "setup-import import-full-screen" },
                [
                  _c("ImportFlatFileStepVue", {
                    on: {
                      closed: function($event) {
                        return _vm.closed(true)
                      },
                      onError: function($event) {
                        return _vm.updateCurrentStepId(3)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.getCurrentStepId !== 4
        ? _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.getCurrentStepId !== 1
                ? _c(
                    "div",
                    {
                      staticClass: "import-popup__btn-back cpointer",
                      on: { click: _vm.onClickBackward }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$l10n.__("Retour")) +
                          "\n        "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("CompassButton", {
                staticClass: "ml-3",
                attrs: {
                  disabled: !_vm.canContinue,
                  label: _vm.labelContinueBtn,
                  size: "large"
                },
                on: { click: _vm.onClickContinue }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }